import React from 'react'
import styles from "./LoaderPage.module.css"
import { Box } from '@primer/react'
import { appConst } from '../../AppConst'
export const LoaderPage = () => {
    return (
        <>
            <div style={{
                height: window.innerHeight - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                <div className={styles.logoContainer}>
                    <img alt='logo' className={styles.logo} style={{ height: "120px" }} src={appConst.appURLLogo} />
                    {/* <div className={styles.lightOverlay}></div> */}
                    <div className={styles.loadingDots} style={{
                        margin: 3
                    }}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                </div>

            </div>
        </>
    )
}

export default LoaderPage